export function main() {
    return new Promise((rs, rj) => {
        console.log('start')
        rs()
    })
}